import { createSlice } from "@reduxjs/toolkit";
export const initialCheckoutFormState = {
    isReady: false,
    shippingStepData: null,
    deliveryStepData: null,
};
export const standardCheckoutForm = createSlice({
    name: "standardCheckoutForm",
    initialState: initialCheckoutFormState,
    reducers: {
        setReady(state) {
            state.isReady = true;
        },
        setShippingStepData(state, action) {
            state.shippingStepData = action.payload;
        },
        setDeliveryStepData(state, action) {
            state.deliveryStepData = action.payload;
        },
    },
});
export const { setShippingStepData, setDeliveryStepData } = standardCheckoutForm.actions;
//# sourceMappingURL=standardCheckoutForm.js.map